const ListSkeleton = ({ count = 4 }) => (
  <div className="space-y-2.5">
    {Array.from({ length: count }).map((_, i) => (
      <div
        key={i}
        className="h-24 rounded-xl bg-white border border-gray-200 animate-pulse"
      />
    ))}
  </div>
);

export default ListSkeleton;
